import '@babel/polyfill';
import Vue from 'vue';
import Auth from '@/plugins/auth';
import Alerts from '@/plugins/alerts';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import '@mdi/font/css/materialdesignicons.css';

import '@/sass/main.scss';

import firebase from '@/plugins/firebase';

Vue.config.productionTip = false;

// Vue.use(VueAxios, axios);


Vue.use(Alerts);

Vue.use(Auth, {
  router,
  onUserChange(uid: string | null, properties?: any) {
    if (uid) {
      store.dispatch('users/fetch', uid).catch(error => Alerts().create(error));
      if (properties) {
        store.commit('users/insertOrUpdate', { uid, ...properties });
      }
      firebase.firestore().collection('users').doc(uid).collection('private')
        .doc('private')
        .onSnapshot((snapshot) => {
          const data = snapshot.data();
          if (data && data.drops) {
            data.drops.forEach((drop: string) => {
              store.dispatch('drops/fetch', drop).catch(error => Alerts().create(error));
            });
          }
          store.commit('users/insertOrUpdate', { ...data, uid, subscribedPrivate: true });
        }, error => console.error(error));
    }
  },
});


const moment = require('moment');
require('moment/min/locales');
Vue.use(require('vue-moment'), {
  moment,
});

Vue.filter('humansize', (bytes: number) => {
  if (!bytes) return '';
  const thresh = 1024;
  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }
  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return `${bytes.toFixed(1)} ${units[u]}`;
});

const vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
